import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client";

/**
 * useReport custom hook for report-related operations.
 * - Provides a method to fetch a guest token for a given role.
 * - Uses Apollo Client's useLazyQuery for on-demand fetching.
 * - Returns helpers for fetching, loading state, error, and data.
 */

// GraphQL Query to get a guest token by role ID
const GET_GUEST_TOKEN = gql`
  query GetGuestToken($roleId: Int!) {
    GetGuestToken(roleId: $roleId) {
      token
    }
  }
`;

export const useReport = () => {
  // useLazyQuery allows fetching the token on demand
  const [getGuestToken, { loading, error, data }] = useLazyQuery(GET_GUEST_TOKEN);

  /**
   * Fetches a guest token for the specified role ID.
   * @param {number|string} roleId - The role ID for which to fetch the token.
   * @returns {Promise<string|undefined>} The guest token if successful.
   */
  const fetchGuestToken = async (roleId) => {
    try {
      const { data } = await getGuestToken({
        variables: { roleId: parseInt(roleId) },
        fetchPolicy: "network-only",
      });
      return data?.GetGuestToken?.token;
    } catch (error) {
      console.error("Error fetching guest token:", error);
      throw error;
    }
  };

  return {
    fetchGuestToken,
    loading,
    error,
    data,
  };
};